jQuery(document).ready(function ($) {

   $(document).on('add_ons_loaded', function (e, $form) {

        var $this  = $($form),
            $contentCoverField = $this.find('#wcss_contents_cover_wrapper'),
            $contentsCoverUploadWrapper = $this.find('#wcss_contents_cover_wrapper_file_upload_wrapper'),
            $contentCoverInputFields = $contentCoverField.find('.radio-group');

        $contentsCoverUploadWrapper.hide();

        $contentCoverInputFields.find('input[type=radio]').on('change', function (e) {
            var $field = $(this),
                wcssData = $field.data('wcss-meta');

            if (wcssData && wcssData['contents_protection_custom_cover'] !== undefined && wcssData['contents_protection_custom_cover']) {
                $contentsCoverUploadWrapper.show();
                $contentsCoverUploadWrapper.find('input[type=file]').prop('required', true);
            } else {
                $contentsCoverUploadWrapper.hide();
                $contentsCoverUploadWrapper.find('input[type=file]').prop('required', false);
            }
        });
    });
});
